import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { server } from "../server";

export const fetchUserProfile = createAsyncThunk(
  "profile/fetchUserProfile",
  async ({ userId, token }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${server}/Profile/GetUserProfile?userObjectId=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch profile");

      const data = await response.json();
      return data; // ✅ return full response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    user: null,
    totalUploaedImages: 0, // 👈 add this
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user; // 👈 store user
        state.totalUploaedImages = action.payload.totalUploaedImages; // 👈 store images
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
